import { render } from "./Inventory.vue?vue&type=template&id=ea8a9176"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/Inventory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ea8a9176"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ea8a9176', __exports__)) {
    api.reload('ea8a9176', __exports__)
  }
  
  module.hot.accept("./Inventory.vue?vue&type=template&id=ea8a9176", () => {
    api.rerender('ea8a9176', render)
  })

}


export default __exports__